/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'checkbox-deselected': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" d="M6 0h12a6 6 0 016 6v12a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6zm0 2a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V6a4 4 0 00-4-4H6z" id="svgicon_checkbox-deselected_a"/></defs><use _fill="#000" xlink:href="#svgicon_checkbox-deselected_a" fill-rule="evenodd"/>'
  }
})
